import { useState } from "react";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import { TkHelpIconProps } from "../../../type/componentsType/TkHelpIcon";
import "./_style.scss";

/**
 * ヘルプアイコン部品
 * アイコンをクリックして補足情報などを表示させる
 * @param {string} helpMessage ツールチップ内に表示するヘルプメッセージ
 * @return TkHelpIcon ヘルプアイコン部品
 */
const TkHelpIcon = (props: TkHelpIconProps & IconButtonProps) => {
  const { helpMessage, onMouseEnter, onMouseLeave, onClick } = props;
  const [open, setOpen] = useState(false);
  const [isClick, setIsCLick] = useState(false);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsCLick(!isClick);

    onClick && onClick(!isClick);
  };

  const mouseEnterHandler = (event: any) => {
    setOpen(true);

    onMouseEnter && onMouseEnter(event);
  };

  const mouseLeaveHandler = (event: any) => {
    setOpen(false);

    onMouseLeave && onMouseLeave(event);
  };

  return (
    <Tooltip
      data-testid="testTooltip"
      className="tooltip"
      arrow
      open={isClick ? true : open}
      title={helpMessage}
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      <IconButton
        className="helpIcon"
        onClick={handleClick}
        data-testid="testIconButton"
      >
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  );
};

export default TkHelpIcon;
